import { render, staticRenderFns } from "./DependencyPanel.vue?vue&type=template&id=25f0f8c6&scoped=true"
import script from "./DependencyPanel.vue?vue&type=script&lang=js"
export * from "./DependencyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0f8c6",
  null
  
)

export default component.exports